import { AvailableBrokerageMovementTable } from "../AvailableBrokerageMovementTable";
import { BrokeragePlanningPeriscope } from "../BrokeragePlanningPeriscope";
import { CoveredBrokerageMovementTable } from "../CoveredBrokerageMovementTable";
import { DeliveredBrokerageMovementTable } from "../DeliveredBrokerageMovementTable";
import { HoldBrokerageMovementTable } from "../HoldBrokerageMovementTable";
import { ProgressBrokerageMovementTable } from "../ProgressBrokerageMovementTable";
import { Button, DataSource, Layout, LayoutHeader, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanning extends Layout {
    buttonCarrierCapacity: Button;
    buttonPartialShipmentPlanningScreen: Button;
    layoutAvailable: AvailableBrokerageMovementTable;
    layoutCovered: CoveredBrokerageMovementTable;
    layoutDelivered: DeliveredBrokerageMovementTable;
    layoutHold: HoldBrokerageMovementTable;
    layoutPeriscope: BrokeragePlanningPeriscope;
    layoutProgress: ProgressBrokerageMovementTable;
    layoutheaderBrokeragePlanning: LayoutHeader;
    sourceBrokerageMovements: DataSource;
    sourceBrokeragePlanningProfile: DataSource;
    sourcePbwLoadboardServices: DataSource;
    tabAvailableOrders: Tab;
    tabCoveredOrders: Tab;
    tabDeliveredOrders: Tab;
    tabHoldOrders: Tab;
    tabInProgressOrders: Tab;
    tabPeriscope: Tab;
    tabsetMain: Tabset;
    textBoxDateRange: Textbox;
}
